import React from 'react';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './LandingLegalPage.css';
import messages from '../../locale/messages';
import LandingLegalPage from './LandingLegalPage';

class LandingTrust extends React.Component {
  render() {
    return (
      <LandingLegalPage
        activePage="trust"
        pageTitleMessage={messages.batch2SafetyH1}
      >
        <section className={s.legalSection}>
          <h2><FormattedMessage {...messages.newLandingLegalTrustHeading} /></h2>
          <p><FormattedMessage {...messages.newLandingLegalTrustIntro} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTrustAiHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalTrustAiText} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTrustIdentityHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalTrustIdentityText} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTrustInsuranceHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalTrustInsuranceText} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTrustPoliciesHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalTrustPoliciesText1} /></p>
          <p><FormattedMessage {...messages.newLandingLegalTrustPoliciesText2} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTrustImprovementHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalTrustImprovementText} /></p>

          <h3><FormattedMessage {...messages.newLandingLegalTrustCommunityHeading} /></h3>
          <p><FormattedMessage {...messages.newLandingLegalTrustCommunityText} /></p>
        </section>
      </LandingLegalPage>
    );
  }
}

export default withStyles(s)(LandingTrust);
